<template>
  <v-container fluid>
    <wapi-panel :title="'Статистика по радарам'">
      <template v-slot:content>
        <v-row>
          <!-- filter -->
          <v-col cols="4">
            <wapi-panel :title="'Фильтр'">
              <template v-slot:content>
                <v-form v-if="isAdmin" ref="formUser" v-model="validUser" lazy-validation>
                  <v-select
                    v-model="userId"
                    :items="users"
                    item-text="name"
                    item-value="id"
                    label="Клиент"
                    @input="onChangeUser"
                    dense
                    outlined
                    :loading="loading"
                    :rules="[exRules.validUser]"
                  ></v-select>
                </v-form>

                <v-checkbox v-model="isMonth" :label="`Выбрать месяц`" dense></v-checkbox>

                <v-form ref="formMonth" v-model="validMonth" lazy-validation>
                  <v-row v-if="isMonth">
                    <v-col cols="12">
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="date"
                            label="Выбор месяца"
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                            :rules="[rules.required, exRules.validDate, exRules.validPeriod]"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date"
                          type="month"
                          no-title
                          scrollable
                          :max="maxDate"
                          @change="refresh"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="okDate(date)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-form>
                <v-form ref="formPeriod" v-model="validPeriod" lazy-validation>
                  <v-row v-if="!isMonth">
                    <!-- dates -->
                    <!-- datestart -->
                    <v-col cols="6">
                      <v-menu
                        ref="menuDateStart"
                        v-model="menuDateStart"
                        :close-on-content-click="false"
                        :return-value.sync="dateStart"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="dateStart"
                            label="Начальная дата"
                            prepend-icon="mdi-calendar"
                            v-on="on"
                            :rules="[rules.required, exRules.validDate, exRules.validPeriod]"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="dateStart"
                          no-title
                          scrollable
                          @change="refresh"
                          :max="maxDate"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menuDateStart = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="okDateStart(dateStart)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6">
                      <!-- dateend -->
                      <v-menu
                        ref="menuDateEnd"
                        v-model="menuDateEnd"
                        :close-on-content-click="false"
                        :return-value.sync="dateEnd"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="dateEnd"
                            label="Конечная дата"
                            prepend-icon="mdi-calendar"
                            v-on="on"
                            :rules="[rules.required, exRules.validDate, exRules.validPeriod]"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="dateEnd"
                          no-title
                          scrollable
                          @change="refresh"
                          :max="maxDate"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menuDateEnd = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="okDateEnd(dateEnd)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-form>
                <v-expansion-panels flat>
                  <v-expansion-panel>
                    <v-expansion-panel-header>Отчет</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-select
                        v-model="territory"
                        :items="territories"
                        item-text="name"
                        item-value="id"
                        label="Территория"
                        :rules="[rules.required]"
                        :loading="territoriesLoading"
                        :disabled="(territories.length === 0) || territoriesLoading || true"
                        dense
                        outlined
                      ></v-select>
                      <v-row class="ma-0">
                        <v-col class="pa-0">
                          <v-btn class="ma-2" color="primary" @click="report()">Выгрузить в EXCEL</v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </template>
            </wapi-panel>
          </v-col>
          <v-col cols="4">
            <wapi-panel :title="'Запросы'">
              <template v-slot:content>
                <v-row no-gutters>
                  <v-col cols="12" md="4">
                    <apexchart
                      type="radialBar"
                      height="150"
                      :options="chartOptions"
                      :series="requestsSeries"
                    ></apexchart>
                  </v-col>
                  <v-col cols="12" md="8">
                    <h2 class="text-center">
                      <strong>{{ radarInfo.current_request_count }} / {{ radarInfo.max_request_count_day }}</strong>
                      <br />
                      <small>Сделано на текущий момент / лимит в сутки</small>
                      <br />
                      <span
                        class="subtitle-2"
                      >[{{ radarInfo.current_validtime_request_count }}] Заблаговременностей запрошено</span>
                      <br />
                      <span
                        class="subtitle-2"
                      >[{{ radarInfo.max_validtime_request_count }}] лимит заблаговременностей в месяц</span>
                    </h2>
                  </v-col>
                </v-row>
              </template>
            </wapi-panel>
          </v-col>
        </v-row>

        <!-- detail -->
        <v-tabs background-color="primary" dark>
          <v-tab>Дни</v-tab>
          <v-tab @click="activateTab">График</v-tab>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-expansion-panels>
                  <v-expansion-panel v-for="(item, index) in radarStatistics" v-bind:key="index">
                    <v-expansion-panel-header>{{ panelTitle(item) }}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <billing-statisctics-detail :model="radarStatistics[index]" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-card flat>
              <v-card-text v-for="item in chartData" v-bind:key="item.id">
                <billing-month-chart-bar
                  :model="item.chartSeries"
                  :chartOptions="item.chartOptions"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </template>
    </wapi-panel>
  </v-container>
</template>

<script>
import WapiPanel from "../../components/WapiPanel";
import moment from "moment";
import BillingStatiscticsDetail from "./components/BillingStatiscticsDetail.vue";
import BillingMonthChartBar from "../../components/billing/BillingMonthChartBar.vue";
import rules from "../../models/helpers/rules";
import radarChartOptions from "./models/radarChartOptions.js";
import { uniqueId } from "../../store/utils.js";

export default {
  name: "UserRadarView",
  title: "Радары",
  components: {
    BillingStatiscticsDetail,
    WapiPanel,
    BillingMonthChartBar
  },
  data: function() {
    return {
      chartData: [],
      validUser: true,
      validMonth: true,
      validPeriod: true,
      isMonth: false,
      counter: 0,
      requestsSeries: [0],
      requestsBaseTimeSeries: [0],
      requestsValidTimeSeries: [0],
      chartOptions: {
        chart: {
          height: 150,
          type: "radialBar"
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "70%"
            }
          }
        },
        labels: [""],
        loading: false
      },
      users: [],
      userId: "",
      presetId: "",
      date: moment()
        .startOf("month")
        .format("YYYY-MM"),
      dateStart: moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      dateEnd: moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      maxDate: moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      dateFormat: "YYYY-MM-DDTHH:mm:ss",
      menu: false,
      menuDateStart: false,
      menuDateEnd: false,
      territory: null,
      territories: [],
      territoriesLoading: false,
      billing: [],
      radarInfo: {},
      loading: false,
      radarStatistics: [],
      chartSeries: [],
      chartDates: [],
      rules: rules,
      exRules: {
        validDate: value => {
          if (this.isValidDate(value)) {
            return true;
          }
          return "Неверная дата!";
        },
        validPeriod: value => {
          if (this.isValidPeriod(value)) {
            return true;
          }
          return `Не должна быть позднее ${this.maxDate}!`;
        },
        validUser: value => {
          if (!this.isAdmin) return true;
          return !!value || "Обязательное поле.";
        },
        existEmail: value => {
          if (this.currentUser.id) {
            return true;
          }
          return (
            !this.users.find(x => x.email === value) || "E-mail уже существует!"
          );
        }
      }
    };
  },
  async created() {
    this.territoriesLoading = true;
    this.territories = await this.$store.dispatch("FETCH_RADAR_TERRITORIES");

    if (this.territories.length) {
      this.territory = this.territories[0];
    }

    this.territoriesLoading = false;
  },
  async mounted() {
    if (this.isAdmin) {
      await this.$store.dispatch("FETCH_USERS");
      this.users = this.$store.getters.USERS;
    }

    await this.refresh();
  },
  computed: {
    isAdmin() {
      return this.$store.getters.IS_ADMIN;
    }
  },
  watch: {
    async isMonth() {
      await this.refresh();
    }
  },
  methods: {
    async report() {
      let from = this.dateStart;
      let to = this.dateEnd;

      if (this.isMonth) {
        from = moment(this.date)
          .startOf("month")
          .format(this.dateFormat);
        to = moment(this.date)
          .endOf("month")
          .endOf("day")
          .format(this.dateFormat);
      }

      if (this.$store.getters.IS_ADMIN) {
        if (!this.$refs.formUser.validate()) return;

        const request = {
          userId: this.userId,
          from: from,
          to: to,
          territory: this.territory
        };
        await this.$store.dispatch("BILLING_USER_REQUESTS_REPORT", request);
      } else {
        const request = {
          userId: this.$store.getters.USER.id,
          from: from,
          to: to,
          territory: this.territory
        };
        await this.$store.dispatch("BILLING_USER_REQUESTS_REPORT", request);
      }
    },
    panelTitle(item) {
      const s1 = `${item.date.substr(0, 10)} количество запросов ${
        item.request_count
      };`;
      if (item.request_limit_exceeded <= 0) {
        return s1;
      } else {
        return `${s1} превышен лимит на ${item.request_limit_exceeded}`;
      }
    },
    okDate(date) {
      if (!this.$refs.formMonth.validate()) return;
      if (this.isAdmin) {
        if (!this.$refs.formUser.validate()) return;
      }
      this.$refs.menu.save(date);
      this.refresh();
    },
    okDateEnd(date) {
      if (!this.$refs.formPeriod.validate()) return;
      if (this.isAdmin) {
        if (!this.$refs.formUser.validate()) return;
      }

      this.$refs.menuDateEnd.save(date);
      this.refresh();
    },
    okDateStart(date) {
      if (!this.$refs.formPeriod.validate()) return;
      if (this.isAdmin) {
        if (!this.$refs.formUser.validate()) return;
      }

      this.$refs.menuDateStart.save(date);
      this.refresh();
    },
    isValidDate(date) {
      const d = moment(date);
      return d.isValid();
    },
    isValidPeriod(date) {
      const d = moment(date);
      return d.isSameOrBefore(this.maxDate, "day");
    },
    activateTab() {},
    async onChangeUser() {
      await this.refresh();
    },
    async refresh() {
      await this.$store.dispatch("SET_LOADING", true);
      const request = {
        userId: this.userId,
        from: this.dateStart,
        to: this.dateEnd,
        take: 1000,
        skip: 0
      };

      if (this.isMonth) {
        request.from = moment(this.date)
          .startOf("month")
          .format(this.dateFormat);
        request.to = moment(this.date)
          .endOf("month")
          .endOf("day")
          .format(this.dateFormat);
      }

      try {
        let stats;
        if (this.$store.getters.IS_ADMIN) {
          if (this.userId) {
            stats = await this.$store.dispatch(
              "FETCH_RADAR_STATISTICS_USER",
              request
            );
          } else {
            await this.$store.dispatch("SET_LOADING", false);
            return;
          }
        } else {
          stats = await this.$store.dispatch("FETCH_RADAR_STATISTICS", request);
        }

        stats.radar_statistics_days.forEach(x => {
          let i = 0;
          x.radar_statistics_day_requests.forEach(r => {
            r["id"] = i++;
          });
        });

        this.radarStatistics = stats.radar_statistics_days.sort(
          (a, b) => new Date(a.date) - new Date(b.date)
        );
        if (this.isAdmin) {
          await this.$store.dispatch("FETCH_USER_RADAR_INFO", request.userId);
        } else {
          await this.$store.dispatch("FETCH_RADAR_INFO");
        }

        this.radarInfo = this.$store.getters.RADAR_INFO;

        this.chartSeries = [
          {
            name: "Количество запросов",
            data: this.radarStatistics.map(
              x => x.request_count - x.request_limit_exceeded
            )
          },
          {
            name: "Превышение лимита",
            data: this.radarStatistics.map(x => x.request_limit_exceeded)
          }
        ];

        this.chartDates = this.radarStatistics.map(x => x.date.substr(0, 10));

        this.chartData = [
          {
            id: uniqueId(),
            chartSeries: this.chartSeries,
            chartOptions: radarChartOptions(this.chartDates)
          }
        ];

        const requestsPersent = Math.round(
          (this.radarInfo.current_request_count /
            this.radarInfo.max_request_count_day) *
            100
        );
        this.requestsSeries = [requestsPersent];
      } finally {
        await this.$store.dispatch("SET_LOADING", false);
      }

      await this.$store.dispatch("SET_LOADING", false);
    }
  }
};
</script>